import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Reservation } from './reservation.model';
import { ReservationService } from './reservation.service';
import { StudentService } from '../student/student.service';
import { LessonService } from '../lesson/lesson.service';

@Injectable()
export class ReservationPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private reservationService: ReservationService,
        private studentService: StudentService,
        private lessonService: LessonService
    ) { }

    open(component: Component, id?: number | any, studentId?: number | any, lessonId?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.reservationService.find(id).subscribe(reservation => {
                this.reservationModalRef(component, reservation);
            });
        } else {
            let r: Reservation = new Reservation();
            let attendedStatus: any = 'ATTENDED';
            r.status = attendedStatus;

            if (studentId) {
                // We are creating a reservation for a specific student
                this.studentService.find(studentId).subscribe(student => {
                    r.student = student;
                    return this.reservationModalRef(component, r);
                });
            } else if (lessonId) {
                // We are creating a reservation for a specific lesson
                this.lessonService.find(lessonId).subscribe(lesson => {
                    r.lesson = lesson;
                    return this.reservationModalRef(component, r);
                });
            } else {
                setTimeout(() => {
                    // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                    return this.reservationModalRef(component, r);
                });
            }

        }
    }

    reservationModalRef(component: Component, reservation: Reservation): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.reservation = reservation;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation-popup.service.ts